import { createFeatureSelector, createSelector } from '@ngrx/store';

import { AddressConfigState, AddressState } from './address.state';

import { Address } from '@features/address';

const selectAddressState = createFeatureSelector<AddressState>('address');

export const getLoadingAddressStatus = createSelector(selectAddressState, (state: AddressState) => state?.loading);
export const getAddressStateLoaded = createSelector(selectAddressState, (state: AddressState) => state.loaded);
export const getAddressEntities = createSelector(selectAddressState, (state: AddressState) => state?.values || {});
export const getAllAddresses = createSelector(getAddressEntities, (values: Record<string, Address>) => {
    const addresses: Address[] = Object.keys(values).map((id: string) => values[id]);
    return addresses;
});

export const getShippingAddresses = createSelector(getAllAddresses, (values: Address[]) =>
    values.filter((address: Address) => address.addressType === 'S'));

export const getBillingAddress = createSelector(
    getAllAddresses,
    (values): Address => values.find((address: Address) => address.addressType === 'SB'),
);

export const getIsBillingAddressVatinStored = createSelector(getAllAddresses, (values) => {
    const billingAddress = values.find((address: Address) => address.addressType === 'SB');
    return billingAddress?.vatin !== null && billingAddress?.vatin !== undefined;
});

export const getShippingAddressesDelivery = (countryCode: string, isWWCountry: boolean) =>
    createSelector(getShippingAddresses, (values) => {
        return values.filter((address) => isWWCountry || address.countryCode === countryCode);
    });

export const getSelectedAddress = createSelector(selectAddressState, (state: AddressState) => state?.selectedAddress);

export const getAddressById = (addressId: string) => createSelector(
    selectAddressState,
    (state: AddressState) => state?.values?.[addressId],
);

export const getAddressConfig = createSelector(selectAddressState, (state: AddressState) => state.config?.values);

export const getAddressTaxCode = createSelector(selectAddressState, (state: AddressState) => state.config?.values.taxCode);

export const getAddressTaxRegimes = createSelector(
    selectAddressState,
    (state: AddressState) => state.config?.values.taxRegimes,
);

export const getIsBillingAddressMandatory = createSelector(
    getAddressConfig,
    (config: AddressConfigState) => config?.isBillingAddressMandatory,
);

export const getIsDocumentMandatory = createSelector(
    getAddressConfig,
    (config: AddressConfigState) => config?.isDocumentMandatory,
);

export const getAddressDocumentTypes = createSelector(
    selectAddressState,
    (state: AddressState) => state.config?.values.documentTypes,
);

export const getAddressConfigDocumentTypeByType = createSelector(
    selectAddressState,
    (state: AddressState) => state.config?.values.documentTypeByType,
);

export const getAddressConfigDocumentTypeByTypeParticular = createSelector(
    selectAddressState,
    (state: AddressState) => state.config?.values.documentTypeByType.particular,
);

export const getAddressConfigDocumentTypeByTypeCompany = createSelector(
    selectAddressState,
    (state: AddressState) => state.config?.values.documentTypeByType.company,
);
